export const FIAT_DECIMALS = 8;

// Currencies Banxa quotes in whole units. Sending fractional amounts for these
// is rejected with a generic error, so the request is snapped to the currency's
// own precision rather than the 8 decimals the amount input allows.
const ZERO_DECIMAL_FIATS = new Set([
  "BIF",
  "CLP",
  "DJF",
  "GNF",
  "IDR",
  "ISK",
  "JPY",
  "KMF",
  "KRW",
  "PYG",
  "RWF",
  "UGX",
  "VND",
  "VUV",
  "XAF",
  "XOF",
  "XPF",
]);

const fiatPrecision = (fiat: string) =>
  ZERO_DECIMAL_FIATS.has(fiat.trim().toUpperCase()) ? 0 : 2;

export const quantizeFiat = (amount: bigint, fiat: string) => {
  const step = 10n ** BigInt(FIAT_DECIMALS - fiatPrecision(fiat));
  return (amount / step) * step;
};
